import { HttpPromiseState, StringControl, Disposers } from 'lib/helpers';
import { environment } from 'lib/environment';
import { httpClient } from 'domain/utils/httpClient';
import { action, observable, reaction, makeObservable } from 'mobx';
import Swal from 'sweetalert2';
import { AxiosResponse } from 'axios'

export interface TeacherWorkDayItemDto {
    readonly DayOfWeek: number;
    readonly StartTime: string;
    readonly EndTime: string;
}

export interface TeacherWorkDayDto {
    readonly Items: TeacherWorkDayItemDto[];
}

export class TeacherWorkDaySceneStore {
    private readonly disposers = new Disposers();

    @observable.ref
    workdayState: HttpPromiseState<TeacherWorkDayDto> | null;

    @observable
    readonly Monday: Map<string, string> = new Map<string, string>();

    @observable
    readonly Tuesday: Map<string, string> = new Map<string, string>();

    @observable
    readonly Wednesday: Map<string, string> = new Map<string, string>();

    @observable
    readonly Thursday: Map<string, string> = new Map<string, string>();

    @observable
    readonly Friday: Map<string, string> = new Map<string, string>();

    @observable
    readonly Saturday: Map<string, string> = new Map<string, string>();

    @observable
    readonly Sunday: Map<string, string> = new Map<string, string>();

    @observable.ref
    ModalOpenDayofweekWithIndex: string | null = null;



    constructor() {
        makeObservable(this);
        this.workdayState = null;
        this.disposers.add(reaction(
            () => this.workdayState?.value,
            (data) => {
                if (!data) {
                    return;
                }
                const items = data.Items;
                let iMonday = 0;
                let iTuesday = 0;
                let iWednesday = 0;
                let iThursday = 0;
                let iFriday = 0;
                let iSaturday = 0;
                let iSunday = 0;

                this.Monday.clear();
                this.Tuesday.clear();
                this.Wednesday.clear();
                this.Thursday.clear();
                this.Friday.clear();
                this.Saturday.clear();
                this.Sunday.clear();

                for (var i = 0; i < items.length; i++) {
                    const item = items[i];
                    const joined = item.StartTime + '-' + item.EndTime;
                    let key;
                    switch (item.DayOfWeek) {
                        case 1:
                            key = "" + iMonday++;
                            this.Monday.set(key, joined);
                            break;
                        case 2:
                            key = "" + iTuesday++;
                            this.Tuesday.set(key, joined);
                            break;
                        case 3:
                            key = "" + iWednesday++;
                            this.Wednesday.set(key, joined);
                            break;
                        case 4:
                            key = "" + iThursday++;
                            this.Thursday.set(key, joined);
                            break;
                        case 5:
                            key = "" + iFriday++;
                            this.Friday.set(key, joined);
                            break;
                        case 6:
                            key = "" + iSaturday++;
                            this.Saturday.set(key, joined);
                            break;
                        case 7:
                            key = "" + iSunday++;
                            this.Sunday.set(key, joined);
                            break;
                    }

                }
            }
        ));
    }

    load = () => {
        this.workdayState = this.getWorkdays();
    }

    private getRequestData(): TeacherWorkDayDto {
        const saveDto: TeacherWorkDayDto = {
            Items: []
        };

        function fnForeach(startEndTime: string, dayOfWeekNum: number) {
            const parts = startEndTime.split('-');
            saveDto.Items.push({
                DayOfWeek: dayOfWeekNum,
                StartTime: parts[0],
                EndTime: parts[1]
            })
        }

        this.Monday.forEach(x => fnForeach(x, 1));
        this.Tuesday.forEach(x => fnForeach(x, 2));
        this.Wednesday.forEach(x => fnForeach(x, 3));
        this.Thursday.forEach(x => fnForeach(x, 4));
        this.Friday.forEach(x => fnForeach(x, 5));
        this.Saturday.forEach(x => fnForeach(x, 6));
        this.Sunday.forEach(x => fnForeach(x, 7));

        return saveDto;
    }

    public async SubmitSave(startTime: string, endTime: string) {
        if (!this.ModalOpenDayofweekWithIndex) {
            return;
        }

        const joined = startTime + '-' + endTime;
        const parts = this.ModalOpenDayofweekWithIndex.split("-");
        if (parts.length != 2) {
            return;
        }
        const dayOfWeek = parts[0];
        const key = parts[1];
        const map = (this as any)[dayOfWeek] as Map<string, string>;
        map.set(key, joined);
        await this.saveWorkdays(this.getRequestData());
        this.workdayState = this.getWorkdays();
        this.ModalOpenDayofweekWithIndex = null;
    }

    public async SubmitDelete() {
        if (!this.ModalOpenDayofweekWithIndex) {
            return;
        }

        var swalResult = await Swal.fire({
            icon: 'question',
            text: 'Confirm delete?',
            confirmButtonText: 'Yes, delete it!',
            showCancelButton: true,
        });
        if (!swalResult.isConfirmed) {
            return;
        }

        const parts = this.ModalOpenDayofweekWithIndex.split("-");
        if (parts.length != 2) {
            return;
        }
        const dayOfWeek = parts[0];
        const key = parts[1];
        const map = (this as any)[dayOfWeek] as Map<string, string>;
        map.delete(key);

        await this.saveWorkdays(this.getRequestData());
        this.workdayState = this.getWorkdays();
        this.ModalOpenDayofweekWithIndex = null;
    }

    private getWorkdays(): HttpPromiseState<TeacherWorkDayDto> {
        let url = `${environment.apiServer}/teacher/work-day-schedule`;
        return httpClient.state.get<TeacherWorkDayDto>(url);
    }

    private saveWorkdays(request: TeacherWorkDayDto): Promise<AxiosResponse<TeacherWorkDayDto>> {
        let url = `${environment.apiServer}/teacher/work-day-schedule`;
        return httpClient.axios.postWithSweetAlert<TeacherWorkDayDto>(url, request);
    }
}